import CampaniasComerciales from './campaniascomerciales.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

var routes = [{
        path: '/campaniacomerciales/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('campaniacomerciales', [], CampaniasComerciales),
        keepAlive: true
    }
];
export default routes;